import React, {
  useEffect,
} from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { useSelector } from "react-redux";

import "./css/SuccessScreen.css";


function SuccessScreen() {

  const {
    restaurantId,
    tableId,
  } = useParams();

  const navigate = useNavigate();

  const location = useLocation();


  /*
  =====================================================
  RESTAURANT NAME
  =====================================================
  */

  const {
    restaurantName,
  } = useSelector(
    (state) => state.theme
  );


  /*
  =====================================================
  SUCCESS DATA
  =====================================================
  */

  const orderId =
    location.state?.orderId ||
    location.state?.order_id ||
    null;


  const paymentMethod =
    location.state?.paymentMethod ||
    "CASH";


  const total =
    Number(
      location.state?.total || 0
    );


  /*
  =====================================================
  PAYMENT LABEL
  =====================================================
  */

  const paymentLabel =
    paymentMethod === "ONLINE"
      ? "ONLINE PAYMENT"
      : "CASH";


  /*
  =====================================================
  AUTO REDIRECT COUNTDOWN
  =====================================================
  */

  const [secondsLeft, setSecondsLeft] =
    React.useState(10);


  useEffect(() => {

    const countdown =
      setInterval(() => {

        setSecondsLeft((previous) => {

          if (previous <= 1) {
            clearInterval(countdown);

            return 0;
          }

          return previous - 1;

        });

      }, 1000);


    const redirect =
      setTimeout(() => {

        navigate(
          `/${restaurantId}/table/${tableId}`
        );

      }, 10000);


    return () => {

      clearInterval(countdown);

      clearTimeout(redirect);

    };

  }, [
    navigate,
    restaurantId,
    tableId,
  ]);


  /*
  =====================================================
  RETURN TO MENU
  =====================================================
  */

  const handleReturnToMenu = () => {

    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  return (

    <div className="theme4-success-page">

      <div className="theme4-success-container">


        {/* =================================================
            TOP DECORATION
        ================================================= */}

        <div className="theme4-success-decoration">

          <span></span>

          <span>
            ✦
          </span>

          <span></span>

        </div>


        {/* =================================================
            SUCCESS ICON
        ================================================= */}

        <div className="theme4-success-mark">

          <div className="theme4-success-ring">

            <span>
              ✓
            </span>

          </div>

        </div>


        {/* =================================================
            MAIN HEADING
        ================================================= */}

        <div className="theme4-success-heading">

          <span className="theme4-success-eyebrow">
            THANK YOU
          </span>


          <h1>
            ORDER
            <br />
            CONFIRMED
          </h1>


          <p>

            Your order has been successfully
            placed at{" "}

            <strong>
              {restaurantName ||
                "the restaurant"}
            </strong>.

          </p>

        </div>


        {/* =================================================
            ORDER CARD
        ================================================= */}

        <div className="theme4-success-card">


          {/* CARD HEADER */}

          <div className="theme4-success-card-header">

            <div>

              <span>
                ORDER
              </span>

              <strong>
                {orderId
                  ? `#${orderId}`
                  : "CONFIRMED"}
              </strong>

            </div>


            <div className="theme4-success-status">

              <span className="theme4-success-status-dot"></span>

              CONFIRMED

            </div>

          </div>


          {/* DIVIDER */}

          <div className="theme4-success-divider"></div>


          {/* ORDER DETAILS */}

          <div className="theme4-success-details">


            {/* RESTAURANT */}

            <div className="theme4-success-detail">

              <span>
                RESTAURANT
              </span>

              <strong>
                {restaurantName ||
                  "Restaurant"}
              </strong>

            </div>


            {/* TABLE */}

            <div className="theme4-success-detail">

              <span>
                TABLE
              </span>

              <strong>
                {tableId}
              </strong>

            </div>


            {/* PAYMENT */}

            <div className="theme4-success-detail">

              <span>
                PAYMENT
              </span>

              <strong>
                {paymentLabel}
              </strong>

            </div>


            {/* TOTAL */}

            <div className="theme4-success-detail theme4-success-total-detail">

              <span>
                TOTAL
              </span>

              <strong>
                ₹{total.toFixed(2)}
              </strong>

            </div>

          </div>


          {/* DIVIDER */}

          <div className="theme4-success-divider"></div>


          {/* STATUS MESSAGE */}

          <div className="theme4-success-message">

            <div className="theme4-success-message-icon">
              ✦
            </div>

            <div>

              <span>
                ORDER STATUS
              </span>

              <p>

                {paymentMethod === "ONLINE"
                  ? "Your payment has been received and your order is being prepared."
                  : "Your order has been sent to the restaurant. Please pay at the restaurant when requested."}

              </p>

            </div>

          </div>

        </div>


        {/* =================================================
            RETURN BUTTON
        ================================================= */}

        <div className="theme4-success-actions">

          <button
            type="button"
            className="theme4-success-primary-button"
            onClick={handleReturnToMenu}
          >

            <span>
              RETURN TO MENU
            </span>

            <strong>
              →
            </strong>

          </button>

        </div>


        {/* =================================================
            COUNTDOWN
        ================================================= */}

        <p className="theme4-success-redirect">

          RETURNING TO MENU IN{" "}

          <strong>
            {secondsLeft}
          </strong>

          {" "}SECONDS

        </p>


        {/* =================================================
            FOOTER
        ================================================= */}

        <p className="theme4-success-footer">

          WE APPRECIATE YOU DINING WITH{" "}

          <span>
            {restaurantName ||
              "US"}
          </span>

        </p>


      </div>

    </div>

  );

}


export default SuccessScreen;